<script setup lang="ts" name="VCardState">
import BaseCardState from '~/components/BaseCardState.vue';
import VCard from '~/components/VCard.vue';

import type {
  BaseCardStateTextColorType,
  IllustrationType,
  IVCardTextColor,
  IVCardTextSize,
} from '~/types';

const {
  title,
  stateTitle,
  stateMessage,
  titleSize,
  titleColor,
  subtitle,
  illustration,
  height,
  stateTitleColor,
} = defineProps<{
  stateTitle?: string;
  stateTitleColor?: BaseCardStateTextColorType;
  title?: string;
  stateMessage?: string;
  height?: string | number;
  titleSize?: IVCardTextSize;
  titleColor?: IVCardTextColor;
  subtitle?: string;
  illustration?: IllustrationType;
}>();
</script>

<template>
  <VCard
    :title="title"
    :height="height"
    :subtitle="subtitle"
    :titleSize="titleSize"
    :titleColor="titleColor"
  >
    <div class="flex h-full flex-col items-center justify-center">
      <slot>
        <BaseCardState
          textSize="card-text-subtitle-1"
          :title="stateTitle"
          :message="stateMessage"
          :illustration="illustration"
          :textColor="stateTitleColor"
        />
      </slot>
    </div>
  </VCard>
</template>
